import momentTz from "moment-timezone";

export const generateInvoicesWithTZ = (invoices) =>
  invoices.map((invoice) => ({
    ...invoice,
    date: momentTz(invoice.date)
      .tz("Europe/Madrid")
      .format("YYYY-MM-DDTHH:mm:ss"),
  }));
